module.exports = __webpack_public_path__ + "static/header-arrows1-8d2bdb6b7921faae0a464243cf2565f1.png";